import type { TCompradoresCadastrados } from '@/features/proposta/brasil/types/proposta.type'
import { StringUtils } from '@/utils'

type TConjuges = TCompradoresCadastrados[number]['vinculos']

export function validarCpfComprador(
  cpfRaw: string,
  compradores: TCompradoresCadastrados,
  conjuges: TConjuges,
): { type: 'SUCCESS' } | { type: 'ERROR'; reason: 'IS_ALREADY_COMPRADOR' | 'IS_ALREADY_CONJUGE' } {
  const cpfIgual = (a?: string | null, b?: string | null) =>
    StringUtils.normalize(a ?? '') === StringUtils.normalize(b ?? '')

  if (conjuges.some((conjuge) => cpfIgual(conjuge.documento, cpfRaw)))
    return { reason: 'IS_ALREADY_CONJUGE', type: 'ERROR' }
  if (compradores.some((c) => cpfIgual(c.documento, cpfRaw))) return { type: 'ERROR', reason: 'IS_ALREADY_COMPRADOR' }
  return { type: 'SUCCESS' }
}
